// components/HomeBanner.jsx
import { useEffect, useState } from "react";
import { fetchHomePage } from "../../services/api";

const HomeBanner = ({ lang }) => {
  const [content, setContent] = useState(null);
  const [fallbackContent, setFallbackContent] = useState(null);
  const [showMain, setShowMain] = useState(false);

  useEffect(() => {
    // Fetch current language
    fetchHomePage(lang).then(setContent);

    // Fetch English fallback if not EN
    if (lang !== "en") {
      fetchHomePage("en").then(setFallbackContent);
    }
  }, [lang]);

  useEffect(() => {
    const timer = setTimeout(() => setShowMain(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  // Helper: get image with fallback
  const getImage = (main, fallback) => main || fallback;

  // Helper: build URL safely
  const getImageUrl = (img) => {
    if (!img) return "/fallback.jpg";

    return (
      process.env.REACT_APP_Base_URL +
      ( img?.url || "")
    );
  };

  if (!content) return <p className="p-6">Loading...</p>;

  // Pick images (JP → fallback to EN)
  const onloadImg = getImage(
    content?.banner_onload_image,
    fallbackContent?.banner_onload_image
  );

  const mainImg = getImage(
    content?.banner_main_image,
    fallbackContent?.banner_main_image
  );

  return (
    <section>
<div className="relative h-[100dvh] overflow-hidden">
      
        {/* Overlay image */}
        <img
          src={getImageUrl(mainImg)}
          alt={mainImg?.name || "Banner Main"}
          className="banner-img-reveal block"
           fetchPriority="high"
  loading="eager"
        />
        {/* className={`banner-img-reveal block ${showMain ? "show" : ""}`} */}

      {/* Text */}
      <h1    className={`banner-text padding-x-40 w-[100%] md:w-[80%] 
  }`}>
        {content?.banner_text ||
          fallbackContent?.banner_text ||
          "No content"}
      </h1>
      </div>
    </section>
  );
};

export default HomeBanner;